import React from 'react';
import './LoaderButton.css';
import PropTypes from 'prop-types';
import Spinner from '../Spinner/Spinner';
import classnames from 'classnames';


const LoaderButton = (props) => {
  return (
    <button className={classnames('my-btn btn-loader', {
        'success': props.check,
        'fail': props.fail
      })}
      >
      <div className="loader-wrapper">
        <Spinner
          stroke="5"
          color="white"
          hide={!props.load}
        />
      </div>
      <p className={classnames({
        'hide': props.check || props.fail || props.load
      })}
      >{props.value}</p>
      <div className={classnames('check', {
        'hide': !props.check
      })}>
        <i className="fas fa-check"></i>
      </div>
      <div className={classnames('fail', {
        'hide': !props.fail
      })}>
        <i className="fas fa-times"></i>
      </div>
    </button>
  );
};


LoaderButton.propTypes = {
  value: PropTypes.string.isRequired,
  load: PropTypes.bool.isRequired,
  check: PropTypes.bool.isRequired,
  fail: PropTypes.bool.isRequired
};


export default LoaderButton;



// WEBPACK FOOTER //
// ./src/components/common/LoaderButton/LoaderButton.js